<ion-app>
  <ion-router-outlet id="content-name" [animated]="animated"></ion-router-outlet>
</ion-app>